/*
 * ***********************************************************************
 * BOUNTEOUS CONFIDENTIAL
 * ___________________
 *
 * Copyright 2019 Bounteous.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property
 * of Bounteous and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Bounteous
 * and its suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Bounteous.
 * ***********************************************************************
 */

import { Component, registerComponent } from 'js/component.js';
import { getNextUniqueCounter } from 'js/helpers.js';

const recaptchaSelector = '.cmp-recaptcha';
const recaptchaComponents = [];

/**
 * Callback triggered on load of the reCAPTCHA library.
 */
window.recaptchaLoaded = () => {
    [...recaptchaComponents].forEach((component) => {
        component.renderWidget();
    });
};

class ReCaptcha extends Component {

    /**
     * Add a listener to capture the form submission event and execute reCAPTCHA.
     */
    addEventListeners() {
        this.form.onsubmit = (event) => {
            let captchaComplete = false;
            [...this.element.getElementsByClassName('g-recaptcha-response')].forEach((ele) => {
                if (ele.value != null && ele.value.length > 0) {
                    captchaComplete = true;
                }
            });

            if (captchaComplete) {
                return true;
            }

            window.grecaptcha.execute(this.recaptchaWidgetId);
            event.preventDefault();
            return false;
        };

        window[this.recaptchaCallbackFunctionName] = () => {
            this.form.submit();
        };
    }

    /**
     * Initialize Component
     */
    init() {
        this.recaptchaCallbackFunctionName = `recaptchaCallback${getNextUniqueCounter()}`;
        this.element.setAttribute('data-callback', this.recaptchaCallbackFunctionName);
        this.form = this.element.closest('form');
        this.addEventListeners();
        recaptchaComponents.push(this);
    }

    /**
     * Render the reCATPCHA widget and capture the ID for execution
     */
    renderWidget() {
        this.recaptchaWidgetId = window.grecaptcha.render(this.element, {}, true);
    }
}

registerComponent(recaptchaSelector, ReCaptcha);
